import React from "react"
import { Loading } from "../../components/parts/loading"
import { Wrapper } from "../../components/templates/wrapper"
import { JSONRPCErrorCatch } from "../../error/error"
import { NotificationActionDispatcher } from "../../libs/notifications"
import { JSONRPCClientBuilder } from "../../request/JSONRPCClientBuilder"
import { UpdateUserInput, User, UserRPC } from "../../rpcs/dist/UserRPC"
import { IContainerProps } from "./container"
import { Form } from "./form/form"
import { IFormField as IAccountFormField } from "./form/validation"
import { Other } from "./other"
import { IFormField as IPasswordFormField } from "./password-form/validation"
import { PasswordForm } from "./password-form/password-form"
import { Tabs } from "../../components/parts/react-tabs-wrapper"
import { Tab, TabList, TabPanel } from "react-tabs"
import Width from "../../style/enum/width"
import { UserIcon } from "../../components/parts/user-icon"
import styled from "styled-components"
import { Headline } from "../../components/parts/headline/headline"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCog } from "@fortawesome/free-solid-svg-icons/faCog"
import { ChangeIconButton } from "../../components/parts/buttons/change-icon-button"

type IProps = IContainerProps & {
  currentUser: User
}

interface IState {
  isInitialized: boolean
}

export class UserSetting extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.accountSubmit = this.accountSubmit.bind(this)
    this.passwordSubmit = this.passwordSubmit.bind(this)
    this.updatedUserInfo = this.updatedUserInfo.bind(this)
    this.receiveImageData = this.receiveImageData.bind(this)

    this.state = {
      isInitialized: false,
    }
  }

  public async componentDidMount() {
    const userRPC = JSONRPCClientBuilder.build(UserRPC)
    const res = await userRPC
      .profile({
        userName: this.props.currentUser.name,
      })
      .catch(JSONRPCErrorCatch)
    if (res !== -1) {
      this.props.actions.updateUserInfo(res)
      this.setState({
        isInitialized: true,
      })
    }
  }

  public render() {
    if (!this.state.isInitialized) {
      return <Loading />
    }

    const {
      profileImage,
      screenName,
      email,
      description,
    } = this.props.currentUser
    return (
      <StyledWrapper maxWidth={Width.EPISODE}>
        <Wrapper defaultHorizontalPadding={true}>
          <Headline>
            <FontAwesomeIcon icon={faCog} /> ユーザー設定
          </Headline>
        </Wrapper>
        <IconWrapper>
          <UserIcon
            size={128}
            title={"ユーザーアイコン"}
            url={profileImage.square}
          />
          <ChangeIconButton receiveImageData={this.receiveImageData} />
        </IconWrapper>
        <Tabs>
          <TabList>
            <Tab>アカウント</Tab>
            <Tab>パスワード</Tab>
            <Tab>その他</Tab>
          </TabList>
          <StyledTabPanel>
            <Form
              onSubmit={this.accountSubmit}
              initialValues={{
                screenName,
                email,
                description,
              }}
            />
          </StyledTabPanel>
          <StyledTabPanel>
            <PasswordForm onSubmit={this.passwordSubmit} />
          </StyledTabPanel>
          <StyledTabPanel>
            <Other />
          </StyledTabPanel>
        </Tabs>
      </StyledWrapper>
    )
  }

  private accountSubmit(values: IAccountFormField) {
    this.updatedUserInfo({
      ...values,
    })
  }

  private passwordSubmit(values: IPasswordFormField) {
    this.updatedUserInfo({
      password: {
        ...values,
      },
    })
  }

  private receiveImageData(imageData: UpdateUserInput["profileImage"]) {
    NotificationActionDispatcher.LogNotification("アイコンを保存しています")
    this.updatedUserInfo({
      profileImage: imageData,
    })
  }

  private async updatedUserInfo(updateUserInput: Omit<UpdateUserInput, "id">) {
    const rpc = JSONRPCClientBuilder.build(UserRPC)
    const res = await rpc.updateUser(updateUserInput).catch(JSONRPCErrorCatch)
    if (res !== -1) {
      // undefinedでemail入っているとチャットルーム開設時にエラーがでるため
      delete res.email
      NotificationActionDispatcher.SuccessNotification("保存が完了しました")
      if (this.props.isUserSwitching) {
        this.props.actions.updateSwitchingUserInfo(res)
      } else {
        this.props.actions.updateUserInfo(res)
      }
    }
  }
}

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 24px 0 24px;
`

const StyledWrapper = styled(Wrapper)`
  margin-bottom: 32px;
`

const StyledTabPanel = styled(TabPanel)`
  padding: 0 16px;
`
